/*! Props generation helper, used to generate common advanced props (shadows, animation...etc) */


// shadows={angle:0,distance:0,color:'',blur:0,spread:0,type:''}
function boxShadow(shadows) {
    if (!shadows) return false;
    let bs = '';
    for (let index = 0; index < shadows.length; index++) {
        let radians = shadows[index].angle * Math.PI / 180;
        let xDistance = Math.cos(radians) * shadows[index].distance;
        let yDistance = Math.sin(radians) * shadows[index].distance;

        if (index === 0) {
            bs = shadows[index].color + ' ' +
                xDistance + 'px ' +
                yDistance + 'px ' +
                shadows[index].blur + 'px ' +
                shadows[index].spread + 'px ' +
                shadows[index].type;
        } else {
            bs += ', ' + shadows[index].color + ' ' +
                xDistance + 'px ' +
                yDistance + 'px ' +
                shadows[index].blur + 'px ' +
                shadows[index].spread + 'px ' +
                shadows[index].type;
        }
    }

    return bs;
}

function multiTextShadow(shadows) {
    if (!shadows) return false;
    let bs = '';
    for (let index = 0; index < shadows.length; index++) {
        let radians = shadows[index].angle * Math.PI / 180;
        let xDistance = Math.cos(radians) * shadows[index].distance;
        let yDistance = Math.sin(radians) * shadows[index].distance;

        if (index === 0) {
            bs = shadows[index].color + ' ' +
                xDistance + 'px ' +
                yDistance + 'px ' +
                shadows[index].blur + 'px';
        } else {
            bs += ', ' + shadows[index].color + ' ' +
                xDistance + 'px ' +
                yDistance + 'px ' +
                shadows[index].blur + 'px';
        }
    }

    return bs;
}

function textShadow(shadow) {
    if (!shadow) return false;

    let radians = shadow.angle * Math.PI / 180;
    let xDistance = Math.cos(radians) * shadow.distance;
    let yDistance = Math.sin(radians) * shadow.distance;

    let bs = shadow.color + ' ' +
        xDistance + 'px ' +
        yDistance + 'px ' +
        shadow.blur + 'px ';
    return bs;
}

function borderProps(border) {

    let borderTop, borderLeft, borderRight, borderBottom, borderColor;

    if (border && border.sides) {
        borderTop = !border.sides.top ? 'none' : border.width + 'px ' + border.style + ' ' + border.color;
        borderLeft = !border.sides.left ? 'none' : border.width + 'px ' + border.style + ' ' + border.color;
        borderRight = !border.sides.right ? 'none' : border.width + 'px ' + border.style + ' ' + border.color;
        borderBottom = !border.sides.bottom ? 'none' : border.width + 'px ' + border.style + ' ' + border.color;
    }

    let borderRadius = border && border.radius ?
        border.radius.topLeft + 'px ' +
        border.radius.topRight + 'px ' +
        border.radius.bottomRight + 'px ' +
        border.radius.bottomLeft + 'px' : null;

    if (border) borderColor = border.color;
    return { borderTop, borderLeft, borderRight, borderBottom, borderRadius, borderColor }
}

function hoverBorderProps(border2, border) {
    border2 = border2 || {};
    border = border || border2;

    let borderTop, borderLeft, borderRight, borderBottom;

    let w = border2.width || border.width;
    let s = border2.style || border.style;
    let c = border2.color || border.color;
    let sides = border2.sides || border.sides;
    let r = border2.radius || border.radius;

    if (sides) {
        borderTop = !sides.top ? 'none' : `${w}px ${s} ${c}`;
        borderLeft = !sides.left ? 'none' : `${w}px ${s} ${c}`;
        borderRight = !sides.right ? 'none' : `${w}px ${s} ${c}`;
        borderBottom = !sides.bottom ? 'none' : `${w}px ${s} ${c}`;
    }

    let borderRadius = r ?
        r.topLeft + 'px ' +
        r.topRight + 'px ' +
        r.bottomRight + 'px ' +
        r.bottomLeft + 'px' : null;

    return { borderTop, borderLeft, borderRight, borderBottom, borderRadius, borderColor:c||false }
}

function textDecoration(font) {
    if (!font || !font.fontStyling) return null;
    let fontStyling = font.fontStyling;

    if (fontStyling['line-through'] && fontStyling.underline) return 'underline line-through';
    else if (fontStyling['line-through']) return 'line-through';
    else if (fontStyling.underline) return 'underline';
    else return null;
}

function getPadding(padding) {
    return padding ?
        padding.top + 'px ' +
        padding.right + 'px ' +
        padding.bottom + 'px ' +
        padding.left + 'px' : null;
}

/*! @omitFontSize: to avoid adding font-size props, this is needed when rendering as fontsize/align is embedded in classes.
/* @omitFontStyle: to avoid adding fontStyling props (Headline, Paragraph) both have their styles embedded in the content. */
function fontProps(font, view="desktop", omitFontSize=false, omitFontStyle=false) {
    if (!font) return {};

    let fontFamily = font.fontFamily;
    let color = font.color;

    let r = {
        color,
        fontFamily,
    }

    if (!omitFontStyle) {
        let fontStyling = font.fontStyling;
        r.fontWeight = fontStyling && fontStyling.bold ? 'bold' : null;
        r.fontStyle = fontStyling && fontStyling.italic ? 'italic' : null;
        r.textDecoration = textDecoration(font);
    }

    if (!omitFontSize) {
        let fontSize = font.fontSize;
        let textAlign = font.textAlign;
        switch (view) {
            case "mobile":
                fontSize = font.mobileFontSize || font.fontSize;
                textAlign = font.mobileTextAlign || font.textAlign;
                break;
            case "tablet":
            case "tablets":
                fontSize = font.tabletFontSize || font.fontSize;
                textAlign = font.tabletTextAlign || font.textAlign;
                break;
        }
        r.fontSize = fontSize + 'px';
        r.textAlign = textAlign;
    }
    return r;
}

function hoverTextDecoration(hoverFont, font) {
    if (!hoverFont || !hoverFont.fontStyling) hoverFont = font;
    let fontStyling = font.fontStyling;
    let hoverStyling = hoverFont.fontStyling||font.fontStyling;
    let r = "";

    if (hoverStyling['line-through'] || fontStyling['line-through']) r += "line-through ";
    if (hoverStyling.underline || fontStyling.underline) r += "underline";

    return r || null;
}

function hoverFontProps(hoverFont, font) {
    hoverFont = hoverFont || {};

    let fontFamily = hoverFont.fontFamily || font.fontFamily;
    let color = hoverFont.color || font.color;

    let r = {
        color,
        fontFamily,
    }

    let fontStyling = hoverFont.fontStyling||font.fontStyling;
    r.fontWeight = fontStyling && fontStyling.bold ? 'bold' : null;
    r.fontStyle = fontStyling && fontStyling.italic ? 'italic' : null;
    r.textDecoration = hoverTextDecoration(hoverFont, font);

    let fontSize = hoverFont.fontSize||font.fontSize;
    let textAlign = hoverFont.textAlign||font.textAlign;
    r.fontSize = fontSize + 'px';
    r.textAlign = textAlign;

    return r;
}

function responsiveAlignStyles(align, id) {
    if (!align) return '';
    if (!align.mobile && !align.tablet) {
        return `.el-${id} {
    align-items: ${align.desktop||'center'};
}`;
    } else {
        return `.el-${id} {
    align-items: ${align.mobile||align.desktop};
}
@media screen and (min-width: 480px) {
  .el-${id} {
    align-items: ${align.tablet||align.desktop};
  }
}
@media screen and (min-width: 1024px) {
  .el-${id} {
    align-items: ${align.desktop||'center'};
  }
}`;
    }
}

/**
 *
 * @param font
 * @param id
 * @param subClass empty by default
 * @returns {string} CSS generated for the given font for all devices in this format .el-${id} [${subClass}] {}
 */
function responsiveFontStyles(font, id, subClass='') {
    if (!font.mobileFontSize && !font.tabletFontSize && !font.mobileTextAlign && !font.tabletTextAlign) {
return `.el-${id} ${subClass} {
    font-size: ${font.fontSize}px;
    text-align: ${font.textAlign};
}`;
    } else {
return `.el-${id} ${subClass} {
    font-size: calc(${font.mobileFontSize || font.fontSize}px + 8 * ((100vw - 320px) / 960));
    text-align: ${font.mobileTextAlign || font.textAlign};
}
@media screen and (min-width: 480px) {
  .el-${id} ${subClass} {
    font-size: calc(${font.tabletFontSize || font.fontSize}px + 8 * ((100vw - 320px) / 960));
    text-align: ${font.tabletTextAlign || font.textAlign};
  }
}
@media screen and (min-width: 1024px) {
  .el-${id} ${subClass} {
    font-size: ${font.fontSize}px;
    text-align: ${font.textAlign};
  }
}`;
    }
}

/**
 * Generates CSS from a given array.
 * @param {Object} props
 */
function generateCss(props) {
    let s = ''
    const camelToSnakeCase = str => str.replace(/[A-Z]/g, letter => `-${letter.toLowerCase()}`);

    Object.keys(props).forEach(p=>{
        let v = props[p];
        if (!v) return;
        let pKey = camelToSnakeCase(p)

        s+=`${pKey}:${v};`
    })
    return s
}

function responsiveOrientationStyles(orientation, id) {
    if (!orientation) return '';
    if (!orientation.mobile && !orientation.tablet) {
        return `.el-${id} {
    flex-direction: ${orientation.desktop||'column'};
}`;
    } else {
        return `.el-${id} {
    flex-direction: ${orientation.mobile||orientation.desktop};
}
@media screen and (min-width: 480px) {
  .el-${id} {
    flex-direction: ${orientation.tablet||orientation.desktop};
  }
}
@media screen and (min-width: 1024px) {
  .el-${id} {
    flex-direction: ${orientation.desktop||'column'};
  }
}`;
    }
}
const capitalize = (s) => {
    if (typeof s !== 'string') return ''
    return s.charAt(0).toUpperCase() + s.slice(1)
}

function setFontSize(font, value, view='desktop') {
    switch (view) {
        case "mobile":
            font.mobileFontSize = value;
            break;
        case "tablet":
        case "tablets":
            font.tabletFontSize = value;
            break;
        default:
            font.fontSize = value;
            break;
    }
}

function setTextAlign(font, value, view='desktop') {
    switch (view) {
        case "mobile":
            font.mobileTextAlign = value;
            break;
        case "tablet":
        case "tablets":
            font.tabletTextAlign = value;
            break;
        default:
            font.textAlign = value;
            break;
    }
}

// falls-back to desktop version.
function getFontSize(font, view='desktop') {
    switch (view) {
        case "mobile":
            return font.mobileFontSize || font.fontSize;
        case "tablet":
        case "tablets":
            return font.tabletFontSize || font.fontSize;
        default:
            return font.fontSize;
    }
}

// falls-back to desktop version.
function getTextAlign(font, view='desktop') {
    switch (view) {
        case "mobile":
            return font.mobileTextAlign || font.textAlign;
        case "tablet":
        case "tablets":
            return font.tabletTextAlign || font.textAlign;
        default:
            return font.textAlign;
    }
}

function getAlignment(align, view='desktop') {
    if (!align) return null;
    switch (view) {
        case "mobile":
            return align.mobile || align.desktop;
        case "tablet":
        case "tablets":
            return align.tablet || align.desktop;
        default:
            return align.desktop;
    }
}

function getOrientation(orientation, view='desktop') {
    if (!orientation) return null;
    switch (view) {
        case "mobile":
            return orientation.mobile || orientation.desktop;
        case "tablet":
        case "tablets":
            return orientation.tablet || orientation.desktop;
        default:
            return orientation.desktop;
    }
}

function letterSpacing(value) {
    return value && value.number ? value.number+'px' : null;
}
function lineHeight(value) {
    return value && value.number ? value.number : null;
}

function trimSrc(url) {
    return '//' + url.replace(/https*:\/\//mgi, '')
}

function backgroundProps(basic) {
    if (!basic) return false;

    let imageUrl = basic.backgroundImage ? trimSrc(basic.backgroundImage) : null;
    let position = 'center ' + basic.backgroundPosition || 'center top';

    if (imageUrl) {
        imageUrl = imageUrl.replace("https://", "")
        if (imageUrl.indexOf("images.funnelish.com")>=0)
            imageUrl = imageUrl.replace("images.funnelish.com", "img.funnelish.com");
        imageUrl = `url("//${imageUrl}?auto=webp&clip=bounds")`;
    }

    let props = { // default props (auto)
        backgroundPosition: position,
        backgroundSize: 'auto',
        backgroundRepeat: 'no-repeat',
        backgroundImage: imageUrl,
    }

    if (basic.backgroundStyle==='cover') {
        props = {
            backgroundPosition: position,
            backgroundSize: '100% auto',
            backgroundRepeat: 'no-repeat',
            backgroundImage: imageUrl,
        }
    }

    return props;
}

export {
    generateCss,
    hoverBorderProps,
    backgroundProps,
    responsiveOrientationStyles,
    getOrientation,
    hoverFontProps,
    responsiveAlignStyles,
    getAlignment,
    getPadding,
    textDecoration,
    borderProps,
    textShadow,
    boxShadow,
    multiTextShadow,
    fontProps,
    setFontSize,
    setTextAlign,
    responsiveFontStyles,
    getFontSize,
    getTextAlign,
    letterSpacing,
    lineHeight
}
